module.exports = __webpack_public_path__ + "static/media/lady-laptop.8c37d001.jpeg";